import { createContext, useContext } from 'react';

import { undoStackInitialValue } from './undoStack.constants';
import { UndoStackContextType } from './undoStack.types';

export const UndoStackContext = createContext<UndoStackContextType>(
  undoStackInitialValue
);

export const useUndoStackContext = () => {
  const context = useContext(UndoStackContext);

  if (!context) {
    throw new Error(
      'useUndoStackContext must be used within a UndoStackProvider'
    );
  }

  return context;
};
